<template src="./Footer.html"> </template>

<script>

export default {
    name: 'Footer',    
}
</script>

<style lang="scss" src="./Footer.scss"> </style>